/** Lead source values used in add-lead forms and list filters. */
export const LEAD_SOURCE_FILTER_OPTIONS = [
  { id: 'Real Estate Brokers/Agents', label: 'Real Estate Brokers/Agents', value: 'Real Estate Brokers/Agents' },
  { id: 'Channel Partners', label: 'Channel Partners', value: 'Channel Partners' },
  { id: 'Property Listing Portals', label: 'Property Listing Portals', value: 'Property Listing Portals' },
  // Written to prelead.type by portal email ingestion. Kept as separate
  // options from the generic "Property Listing Portals" above because the
  // question a builder actually asks at renewal time is which portal paid
  // off, and one merged bucket cannot answer it. Values match the
  // EmailLeadPortal enum exactly — they are a stored data contract.
  { id: '99acres', label: '99acres (Portal Email)', value: '99acres' },
  { id: 'housing', label: 'Housing.com (Portal Email)', value: 'housing' },
  { id: 'nobroker', label: 'NoBroker (Portal Email)', value: 'nobroker' },
  { id: 'magicbricks', label: 'MagicBricks (Portal Email)', value: 'magicbricks' },
  { id: 'squareyards', label: 'Square Yards (Portal Email)', value: 'squareyards' },
  { id: 'Google Ads', label: 'Google Ads', value: 'Google Ads' },
  { id: 'Facebook', label: 'Facebook', value: 'Facebook' },
  { id: 'facebook', label: 'Facebook (Campaign)', value: 'facebook' },
  { id: 'Instagram', label: 'Instagram', value: 'Instagram' },
  { id: 'LinkedIn', label: 'LinkedIn', value: 'LinkedIn' },
  { id: 'Company Website', label: 'Company Website', value: 'Company Website' },
  { id: 'website', label: 'Website (Campaign)', value: 'website' },
  {
    id: 'Walk-ins from Project Signage/Hoardings',
    label: 'Walk-ins from Project Signage/Hoardings',
    value: 'Walk-ins from Project Signage/Hoardings'
  },
  {
    id: 'Existing Customer Referrals (Word of Mouth)',
    label: 'Existing Customer Referrals (Word of Mouth)',
    value: 'Existing Customer Referrals (Word of Mouth)'
  },
  { id: 'Friends/Family', label: 'Friends/Family', value: 'Friends/Family' },
  { id: 'Tele-calling Campaigns', label: 'Tele-calling Campaigns', value: 'Tele-calling Campaigns' },
  { id: 'Email or WhatsApp Campaigns', label: 'Email or WhatsApp Campaigns', value: 'Email or WhatsApp Campaigns' },
  { id: 'Offline Events & Exhibitions', label: 'Offline Events & Exhibitions', value: 'Offline Events & Exhibitions' },
  { id: 'whatsapp_outbound', label: 'WhatsApp Outbound', value: 'whatsapp_outbound' },
  { id: 'self', label: 'Self', value: 'self' }
];

export function getLeadSourceFilterLabel(value) {
  if (!value) return null;
  return LEAD_SOURCE_FILTER_OPTIONS.find((option) => option.value === value)?.label ?? value;
}
